import { applyPostcodeAction } from '../../../_flux/actions/postcode_actions';
import MapActions from '../../../_flux/actions/map_actions';
import { createLatLangObjectFromString } from '../../../_flux/helper/gmap';
import { getValue } from '../../../utilities/local_storage';

export const loadAndDisplayCartData = async ($cartCount) => {
    const postcode = getValue('shippingPostcode');
    const latLng = getValue('latLng');
    if (postcode && latLng) {
        applyPostcodeAction(postcode);
        const { lat, lng } = latLng;
        try {
            if (lat && lng) {
                let newLatLng = createLatLangObjectFromString(
                    parseFloat(lat),
                    parseFloat(lng)
                );

                if (false !== newLatLng.lat() && false !== newLatLng.lng()) {
                    MapActions.setLatLngAction(newLatLng);
                }

                // MapActions.updateLatLngAction(postcode);
            }
        } catch (error) {
            console.log('::', latLng);
        }
    }
    window.$cartCount = $cartCount;
};
